export const SERVICES_URL = process.env.SERVICES_URL;
export const EBIS_GLOBAL_SERVICES_URL = process.env.EBIS_GLOBAL_SERVICES_URL;
